import { DOCS_URLS } from "@p0security/frontend-core";
import { ContactSupport } from "@p0security/frontend-core/react";
import { Typography } from "@p0security/ui";
import { Link } from "react-router-dom";

export const Footer: React.FC<object> = () => {
  return (
    <Typography.Paragraph>
      If you have any questions, please refer to our{" "}
      <Link to={DOCS_URLS.BASE} target="_blank" rel="noreferrer">
        documentation
      </Link>
      &nbsp;or&nbsp;
      <ContactSupport />
    </Typography.Paragraph>
  );
};
